// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"68cc92d9","488":"1fb642b6","977":"4e0467b8"}[chunkId] + ".chunk.js";
};